{
  "it": {
    "todo_list": {
      "actions": {
        "add": "Crea elenco attività",
        "cancel": "Annulla",
        "delete_todo_list": "Elimina elenco",
        "edit": "Modifica elenco attività",
        "new": "Elenco attività",
        "save": "Salva",
        "title": "Titolo dell'elenco"
      },
      "attributes": {
        "name": "Titolo"
      },
      "labels": {
        "assignToLevel": "Assegna a livello",
        "createdAt": "Creato il",
        "filter_employee": "Responsabile",
        "newTodoList": "Nuovo elenco attività",
        "sort": {
          "created_at_asc": "Meno recenti",
          "created_at_desc": "Più recenti",
          "name_lower_asc": "Titolo A -> Z",
          "name_lower_desc": "Titolo Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Tenga sotto controllo le attività Sue e del Suo team.",
            "title": "Apri un nuovo elenco attività"
          }
        }
      },
      "toasts": {
        "create": "Elenco attività creato con successo",
        "delete": "Elenco attività eliminato con successo",
        "update": "Elenco attività aggiornato con successo"
      },
      "validation": {
        "needTitle": "Titolo obbligatorio"
      }
    }
  }
}
